import { logger } from '../helpers/logger';
import { toApiError } from './apiError';

const isLoginRequest = (url = '') => url === '/login' || url.endsWith('/login');

const readActionType = (data) => {
  if (typeof data !== 'string') {
    return data?.actionType;
  }

  try {
    return JSON.parse(data)?.actionType;
  } catch {
    return undefined;
  }
};

export const describeRequest = (config = {}, status, now = Date.now()) => {
  const method = (config.method || 'get').toUpperCase();
  const actionType = readActionType(config.data);
  const startedAt = config.metadata?.startedAt;
  const elapsed = startedAt === undefined ? '?' : now - startedAt;

  return `${method} ${config.url}${actionType ? ` ${actionType}` : ''} → ${status} (${elapsed}ms)`;
};

export const prepareRequest = (config, now = Date.now()) => {
  const token = localStorage.getItem('access_token');
  const s3Url = process.env.REACT_APP_AMAZON_S3_URL;
  const isAmazonS3Upload = Boolean(s3Url) && config.url.includes(s3Url);
  if (!isAmazonS3Upload && token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return { ...config, metadata: { startedAt: now } };
};

export const logResponse = (response) => {
  logger.debug(describeRequest(response.config, response.status));
  return response;
};

export const rejectAsApiError = (error) => {
  const apiError = toApiError(error);
  logger.debug(describeRequest(error?.config, apiError.status));

  if (apiError.status === 401 && !isLoginRequest(error?.config?.url)) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('loginTime');
    window.location.href = '/login';
  }

  return Promise.reject(apiError);
};
